import "whatwg-fetch";
import {
  getAPIConfig,
  handleAPIResponse,
  convertQueryObjToString,
} from "@utils/browser-helpers";
import { executeAPIRequest } from "@adapters/api";
import type { SelectClientsAdapter, ClientCTIDsResponse, ConfirmClientResponse, ConfirmSessionResponse } from "../types";

const selectClientsAdapter: SelectClientsAdapter = {
  fetchAllClientCTIDs: async (paramConfig?: Record<string, any>): Promise<ClientCTIDsResponse> => {
    const route = `/user_clients${
      paramConfig ? convertQueryObjToString(paramConfig, true) : ""
    }`;
    const apiConfig = getAPIConfig(route, false);
    const response = await executeAPIRequest(apiConfig, "GET");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },
  fetchCommercialClientCTIDs: async (paramConfig?: Record<string, any>): Promise<ClientCTIDsResponse> => {
    const route = `/commercial/user_clients${
      paramConfig ? convertQueryObjToString(paramConfig, true) : ""
    }`;
    const apiConfig = getAPIConfig(route, false);
    const response = await executeAPIRequest(apiConfig, "GET");
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  },
  fetchSelectClientInitialAuth: async (): Promise<any> => {
    const authConfig = getAPIConfig("/select-clients-jwt", false, false, true);
    const authResponse = await executeAPIRequest(authConfig, "GET");
    const authResponseData = await authResponse.json();
    return handleAPIResponse(authResponseData);
  },

  confirmClient: async (confirmation: { clienttype_id: number }): Promise<ConfirmClientResponse> => {
    const apiConfig = getAPIConfig("/select_client", false);
    const confirmResponse = await executeAPIRequest(
      apiConfig,
      "POST",
      undefined,
      confirmation
    );
    try {
      const Authorization = confirmResponse.headers.get("Authorization");
      const confirmedResponseData = await confirmResponse.json();
      return handleAPIResponse({ ...confirmedResponseData, Authorization });
    } catch (err) {
      console.warn(err);
      return handleAPIResponse(confirmResponse);
    }
  },
  confirmCommercialClient: async (confirmation: { clienttype_id: number }): Promise<ConfirmClientResponse> => {
    const apiConfig = getAPIConfig("/commercial/select_client", false);
    const confirmResponse = await executeAPIRequest(
      apiConfig,
      "POST",
      undefined,
      confirmation
    );
    try {
      const Authorization = confirmResponse.headers.get("Authorization");
      const confirmedResponseData = await confirmResponse.json();
      return handleAPIResponse({ ...confirmedResponseData, Authorization });
    } catch (err) {
      console.warn(err);
      return handleAPIResponse(confirmResponse);
    }
  },
  confirmNewSession: async (newConfirmation: { clienttype_id: number }): Promise<ConfirmSessionResponse> => {
    const apiConfig = getAPIConfig("/", false, false, true);
    const confirmNewResponse = await executeAPIRequest(
      apiConfig,
      "POST",
      { CTID: newConfirmation.clienttype_id },
      newConfirmation
    );
    try {
      const confirmedNewResponseData = await confirmNewResponse.json();
      return handleAPIResponse(confirmedNewResponseData);
    } catch (err) {
      console.warn(err);
      return handleAPIResponse(confirmNewResponse);
    }
  },
};

(window as any).selectClientsAdapter = selectClientsAdapter;

export default selectClientsAdapter;
